module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold_1.183f0be7.ttf";